import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import './viewReport.css'
// import Calendar from '@/components/internal/utils/calendar';
import axios from './../../axios'
import Calendar from './CalendarView/Calendar';
import { ScrollArea } from "./../../components/ui/scroll-area"
import { Label } from '../../components/ui/label'
import { Input } from './../../components/ui/input'
import { Button } from './../../components/ui/button'
import { Badge } from './../../components/ui/badge'
import { Card, CardContent } from '../../components/ui/card'
import { toast } from 'react-toastify';


function ViewReport() {
    const studentData = JSON.parse(localStorage.getItem('breathForStudent'))
    const [student, setStudent] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [details, setDetails] = useState([]);
    const [showTable, setShowTable] = useState(false);

    const holidayInfo = [
        {
            stat: 'Working Days',
            color: 'amber',
            workingDays: 7,
            count: details?.workingDays || '-',
        },
        {
            stat: 'Present',
            color: 'green',
            count: details?.presentCount || '-',
        },
        {
            stat: 'Delay',
            color: 'yellow',
            count: details?.delayCount || '-',
        },
        {
            stat: 'Absent',
            color: 'red',
            count: details?.absentCount || '-',
        },
        {
            stat: 'Leave',
            color: 'cyan',
            count: details?.leaveCount || '-',
        },
    ];

    const handleGatStudentAttendanceReport = async () => {
        try {
            const resp = await axios.get(`/leaveMngmt/getStudentDetails?academicSessionId=${studentData?.academic_session?.id}&timetableSessionId=${studentData?.timetable_session?.id}&standardId=${studentData?.standard?.id}&sectionId=${studentData?.section?.id}&startDate=${startDate}&endDate=${endDate}&studentId=${studentData?.id}`)
            // const resp = await axios.get(`/attendance/getByStudent/student/${studentData?.id}?startDate=${startDate}&endDate=${endDate}`)
            setDetails(resp?.data?.data)
        } catch (error) {
            console.log("error", error)
            toast.error("Something went wrong!!")
        }
    }

    const getReportFunction = () => {
        handleGatStudentAttendanceReport()
        setShowTable(true);
    };
    return (
        <div>
            <ScrollArea className="h-[calc(100vh-100px)] w-full overflow-auto">
                <Card>
                    <CardContent className="space-y-3 p-3">
                        {/* Student Info */}
                        <div className="flex justify-around flex-row p-4 card">
                            <div className="space-y-1 text-center">
                                <p className="text-lg font-semibold">
                                    Student Name: {studentData?.name}
                                </p>
                                <p>
                                    Class:{' '}
                                    <span className="font-medium">
                                        {studentData?.standard.name}
                                    </span>
                                </p>
                                <p>
                                    Section:{' '}
                                    <span className="font-medium">
                                        {studentData?.section.name}
                                    </span>
                                </p>
                                <p>
                                    Roll Code: <span className="font-medium">
                                        {studentData?.code}
                                    </span>
                                </p>
                            </div>

                            {/* Date Picker & Button */}
                            <div className="mt-1 flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center gap-4">
                                    <div>
                                        <Label className="text-md font-semibold">Start Date</Label>
                                        <Input
                                            type="date"
                                            placeholder="Start Date"
                                            className="w-36"
                                            onChange={(e) => setStartDate(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <Label className="text-md font-semibold">End Date</Label>
                                        <Input
                                            type="date"
                                            placeholder="End Date"
                                            className="w-36"
                                            onChange={(e) => setEndDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <Button
                                    className="mt-4 bg-[#F77F00] text-white hover:bg-[#e76f00]"
                                    onClick={getReportFunction}
                                    variant='ghost'
                                    disabled={!startDate || !endDate || startDate > endDate}
                                >
                                    Get Report
                                </Button>
                            </div>
                        </div>

                        {/* Attendance Summary */}
                        {showTable && <div className="py-8">
                            <div className="flex items-center justify-between">
                                <h1 className="text-lg font-semibold">Attendance Summary</h1>
                                <div className="space-x-1 text-sm">
                                    <span className="text-green-600">Present (P)</span>{' '}
                                    <span className="text-yellow-600">Delay (D)</span>{' '}
                                    <span className="text-red-600">Absent (A)</span>{' '}
                                    <span className="text-cyan-600">Leave (L)</span>{' '}
                                    <span className="text-gray-500">Holiday (H)</span>{' '}
                                    <span>Not Taken (NT)</span>
                                </div>
                            </div>
                            <div className="grid grid-cols-7 gap-4 rounded-lg border p-4">
                                <div className="col-span-2 mt-2 flex flex-col gap-2">
                                    <p className="font-semibold">
                                        {!startDate || !endDate
                                            ? 'Select Date'
                                            : `${startDate} - ${endDate}`}
                                    </p>
                                    <p className="text-xl font-semibold">
                                        Attendance : {details ? details?.attendancePercentage : '-'} [
                                        {details ? details?.presentCount + details?.delayCount : 'NA'}{' '}
                                        / {details ? details?.workingDays : 'NA'}]
                                    </p>
                                </div>
                                {holidayInfo.map((info, index) => (
                                    <div key={index} className="text-center">
                                        <p className={`font-semibold text-${info.color}-600`}>
                                            {info.stat}
                                        </p>
                                        <Badge
                                            variant="outline"
                                            className="px-3 py-1"
                                        >
                                            <span className='text-2xl'>{info.count}</span>
                                        </Badge>
                                    </div>
                                ))}
                            </div>
                        </div>}

                        {/* Attendance Details */}
                        {showTable && <div>
                            <Calendar
                                attendanceRecords={details?.attendanceRecords || []}
                                details={details}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>}
                    </CardContent>
                </Card>
            </ScrollArea>

        </div>
    )
}

export default ViewReport